module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_warning-5bb24629570b1dc510458d6286c18848.png";